import React from "react"
import { useTranslation } from "react-i18next"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import "./styles/_project-option.scss"

interface ProjectOptionNewProps extends WithClassName {
  title: string
}

export const ProjectOptionNew = React.memo(
  ({ className }: ProjectOptionNewProps) => {
    const { t } = useTranslation()

    return (
      <div className={classNames("project-option", className)}>
        <div>
          <Icon name={IconName.PLUS_CIRCLE_SOLID} />
        </div>

        <div className="project-option__create-label">
          {t("Project.Actions.Create")}
        </div>
      </div>
    )
  }
)
